import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect } from "react";
import { a as useToggletipContext, b as useMergeRefs, F as FloatingPortal, c as FloatingArrow } from "../../../../chunks/useToggletip-BRp4_0cB.js";
import { s as styles } from "../../../../chunks/Toggletip.module-D9Zn2F9e.js";
const ToggletipPopover = forwardRef(
  function ToggletipPopover2({ style, id, ...props }, propRef) {
    const { arrowRef, context: floatingContext, ...context } = useToggletipContext();
    const ref = useMergeRefs([context.refs.setFloating, propRef]);
    useEffect(() => {
      function handleKeyDown(event) {
        if (event.key === "Tab" && floatingContext.open) {
          floatingContext.onOpenChange(false);
        }
      }
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }, [floatingContext]);
    if (!floatingContext.open) return null;
    return /* @__PURE__ */ jsx(FloatingPortal, { id, children: /* @__PURE__ */ jsxs(
      "div",
      {
        ref,
        style: { ...context.floatingStyles, ...style },
        className: styles.toggletipPopover,
        ...context.getFloatingProps(props),
        children: [
          props.children,
          /* @__PURE__ */ jsx(
            FloatingArrow,
            {
              ref: arrowRef,
              context: floatingContext,
              className: styles.toggletipArrow
            }
          )
        ]
      }
    ) });
  }
);
export {
  ToggletipPopover
};
